import React from "react";
import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>zhangying </h1>
        <h1>pnpm </h1>
      </header>
    </div>
  );
}

export default App;
